(function infracenterCroEnhancements() {
  'use strict';

  const GUIDE_LINK_SELECTOR = '[href="#dt-product-guide"]';
  const GUIDE_TRIGGER_SELECTOR = '#dt-cta .dt-flag';
  const GUIDE_CONTENT_SELECTOR = '#dt-pg-root, #dt-guide-content';
  const RATING_SELECTOR = '.lipscore-rating-small, #lipscore-rating, .lipscore-rating';
  const FILTER_APPLY_SELECTOR = 'facet-filters input:not([name="sort_by"]), facet-filters .active-filter, facet-filters .js-clear-filter, facet-filters .js-clear-all';
  const SORT_SELECTOR = '[name="sort_by"]';
  const GUIDE_TIMEOUT = 10000;

  function sectionIdFor(element) {
    const section = element && element.closest('[id^="shopify-section-"]');
    return section ? section.id.replace('shopify-section-', '') : undefined;
  }

  function emitCro(name, element) {
    if (!name) return;

    const detail = {
      name,
      pageType: document.body ? document.body.dataset.pageType || '' : '',
      sectionId: sectionIdFor(element)
    };
    const productId = element && (element.dataset.productId || element.closest('[data-product-id]')?.dataset.productId);
    if (productId) detail.productId = productId;

    document.dispatchEvent(new CustomEvent('infracenter:cro', { detail }));
  }

  function showGuideError(source) {
    const host = source.closest('.text-overlay, .card--promo__info, .section__block, .banner__text, .overlay__content') || source.parentElement;
    if (!host) return;

    let status = host.querySelector('.cro-guide-status');
    if (!status) {
      status = document.createElement('span');
      status.className = 'cro-guide-status';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      host.appendChild(status);
    }
    status.textContent = 'Guiden kunde inte öppnas. Ring 0771-22 55 00 så hjälper vi dig.';
  }

  function focusGuideContent() {
    const content = document.querySelector(GUIDE_CONTENT_SELECTOR);
    if (!content || content.getClientRects().length === 0 || content.getAttribute('aria-hidden') === 'true') return false;
    if (!content.hasAttribute('tabindex')) content.setAttribute('tabindex', '-1');
    content.focus({ preventScroll: false });
    return true;
  }

  function waitForGuideContent(source) {
    if (focusGuideContent()) return;

    const observer = new MutationObserver(() => {
      if (!focusGuideContent()) return;
      observer.disconnect();
      window.clearTimeout(timeoutId);
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'aria-hidden', 'open']
    });
    const timeoutId = window.setTimeout(() => {
      observer.disconnect();
      showGuideError(source);
    }, GUIDE_TIMEOUT);
  }

  function openGuide(source) {
    const trigger = document.querySelector(GUIDE_TRIGGER_SELECTOR);
    if (trigger) {
      trigger.click();
      waitForGuideContent(source);
      return;
    }

    // The homepage must receive the same Pop-in CTA placement as collections.
    // Wait for that existing CTA instead of creating an embedded guide here.
    const observer = new MutationObserver(() => {
      const delayedTrigger = document.querySelector(GUIDE_TRIGGER_SELECTOR);
      if (delayedTrigger) {
        observer.disconnect();
        window.clearTimeout(timeoutId);
        delayedTrigger.click();
        waitForGuideContent(source);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    const timeoutId = window.setTimeout(() => {
      observer.disconnect();
      showGuideError(source);
    }, GUIDE_TIMEOUT);
  }

  function enhanceGuideLinks(root) {
    if (root.matches && root.matches(GUIDE_LINK_SELECTOR) && !root.dataset.croEvent) {
      root.dataset.croEvent = 'guide_open';
    }
    root.querySelectorAll(GUIDE_LINK_SELECTOR).forEach((link) => {
      if (!link.dataset.croEvent) link.dataset.croEvent = 'guide_open';
    });
  }

  function enhanceEventHooks(root) {
    if (root.matches && root.matches(FILTER_APPLY_SELECTOR)) root.dataset.croEvent = 'filter_apply';
    if (root.matches && root.matches(SORT_SELECTOR)) root.dataset.croEvent = 'sort_change';
    root.querySelectorAll(FILTER_APPLY_SELECTOR).forEach((control) => {
      control.dataset.croEvent = 'filter_apply';
    });
    root.querySelectorAll(SORT_SELECTOR).forEach((control) => {
      control.dataset.croEvent = 'sort_change';
    });
  }

  function ratingVotes(rating) {
    const voteSource = rating.querySelector('[data-ls-product-votes], [data-ls-product-review-count], [data-ls-product-rating-count], [data-ls-review-count], [data-ls-votes]');
    const sourceData = voteSource ? voteSource.dataset : {};
    const rawVotes = rating.dataset.lsProductVotes
      || rating.dataset.lsProductReviewCount
      || rating.dataset.lsProductRatingCount
      || rating.dataset.lsReviewCount
      || rating.dataset.lsVotes
      || sourceData.lsProductVotes
      || sourceData.lsProductReviewCount
      || sourceData.lsProductRatingCount
      || sourceData.lsReviewCount
      || sourceData.lsVotes
      || '';
    const parsed = Number.parseInt(rawVotes.replace(/\D/g, ''), 10);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function ratingValue(rating) {
    const valueSource = rating.querySelector('[data-ls-product-rating], [data-ls-rating]');
    const sourceData = valueSource ? valueSource.dataset : {};
    const rawRating = rating.dataset.lsProductRating
      || rating.dataset.lsRating
      || sourceData.lsProductRating
      || sourceData.lsRating
      || '';
    const parsed = Number.parseFloat(rawRating.replace(',', '.'));
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function renderRatingStars(rating, value) {
    if (value <= 0 || rating.querySelector('.lipscore-rating-star, .cro-rating-stars')) return;

    const stars = document.createElement('span');
    stars.className = 'cro-rating-stars';
    stars.setAttribute('aria-hidden', 'true');

    for (let index = 1; index <= 5; index += 1) {
      const star = document.createElement('span');
      const starValue = value / 2;
      star.className = starValue >= index ? 'cro-rating-star cro-rating-star--full'
        : starValue >= index - 0.5 ? 'cro-rating-star cro-rating-star--half'
          : 'cro-rating-star cro-rating-star--empty';
      star.textContent = '★';
      stars.appendChild(star);
    }

    rating.prepend(stars);
  }

  function addRatingLabel(rating, value) {
    if (rating.querySelector('.cro-rating-label') || value <= 0) return;

    const label = document.createElement('span');
    label.className = 'cro-rating-label visually-hidden';
    label.textContent = `${(value / 2).toLocaleString('sv-SE', { maximumFractionDigits: 1 })} av 5 stjärnor`;
    rating.appendChild(label);
  }

  function enhanceRating(rating) {
    const votes = ratingVotes(rating);
    const value = ratingValue(rating);
    let count = rating.querySelector('.cro-rating-count');

    if (votes > 0) {
      rating.classList.remove('cro-rating-empty');
      renderRatingStars(rating, value);
      addRatingLabel(rating, value);
      if (!count) {
        count = document.createElement('span');
        count.className = 'cro-rating-count';
        rating.appendChild(count);
      }
      const countText = `(${votes})`;
      const countLabel = votes === 1 ? '1 omdöme' : `${votes} omdömen`;
      if (count.textContent !== countText) count.textContent = countText;
      if (count.getAttribute('aria-label') !== countLabel) count.setAttribute('aria-label', countLabel);
      return;
    }

    if (count) count.remove();
    const visibleText = rating.textContent.trim();
    rating.classList.toggle('cro-rating-empty', value <= 0 && visibleText === '');
  }

  function enhanceRatings(root) {
    if (root.matches && root.matches(RATING_SELECTOR)) enhanceRating(root);
    root.querySelectorAll(RATING_SELECTOR).forEach(enhanceRating);
  }

  document.addEventListener('click', (event) => {
    const target = event.target.closest('[data-cro-event]');
    if (!target) return;

    const eventName = target.dataset.croEvent;
    if (eventName === 'sort_change' || eventName === 'filter_apply') return;
    emitCro(eventName, target);

    if (eventName === 'guide_open') {
      event.preventDefault();
      openGuide(target);
    }
  });

  document.addEventListener('change', (event) => {
    const sortControl = event.target.closest('[name="sort_by"], .products-toolbar__sort');
    if (sortControl) {
      emitCro('sort_change', sortControl);
      return;
    }

    if (event.target.closest('facet-filters')) emitCro('filter_apply', event.target);
  });

  document.addEventListener('click', (event) => {
    const appliedFilter = event.target.closest('facet-filters .active-filter, facet-filters .js-clear-filter, facet-filters .js-clear-all');
    if (appliedFilter) emitCro('filter_apply', appliedFilter);
  });

  function initialize() {
    enhanceGuideLinks(document);
    enhanceEventHooks(document);
    enhanceRatings(document);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.target.matches?.(RATING_SELECTOR)) {
          enhanceRating(mutation.target);
          return;
        }
        const mutatedRating = mutation.target.closest?.(RATING_SELECTOR);
        if (mutatedRating) enhanceRating(mutatedRating);
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return;
          const containingRating = node.closest?.(RATING_SELECTOR);
          if (containingRating) enhanceRating(containingRating);
          enhanceGuideLinks(node);
          enhanceEventHooks(node);
          enhanceRatings(node);
        });
      });
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: [
        'data-ls-product-votes',
        'data-ls-product-review-count',
        'data-ls-product-rating-count',
        'data-ls-review-count',
        'data-ls-votes',
        'data-ls-product-rating',
        'data-ls-rating'
      ]
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
}());
